export var ToggleMethods;
(function (ToggleMethods) {
    ToggleMethods["on"] = "on";
    ToggleMethods["ON"] = "ON";
    ToggleMethods["off"] = "off";
    ToggleMethods["OFF"] = "OFF";
    ToggleMethods["toggle"] = "toggle";
    ToggleMethods["TOGGLE"] = "TOGGLE";
    ToggleMethods["determinate"] = "determinate";
    ToggleMethods["DETERMINATE"] = "DETERMINATE";
    ToggleMethods["indeterminate"] = "indeterminate";
    ToggleMethods["INDETERMINATE"] = "INDETERMINATE";
    ToggleMethods["enable"] = "enable";
    ToggleMethods["ENABLE"] = "ENABLE";
    ToggleMethods["disable"] = "disable";
    ToggleMethods["DISABLE"] = "DISABLE";
    ToggleMethods["readonly"] = "readonly";
    ToggleMethods["READONLY"] = "READONLY";
    ToggleMethods["destroy"] = "destroy";
    ToggleMethods["DESTROY"] = "DESTROY";
    ToggleMethods["rerender"] = "rerender";
    ToggleMethods["RENDERER"] = "RENDERER";
})(ToggleMethods || (ToggleMethods = {}));
